import { createFileRoute } from '@tanstack/react-router';
import { LocationsPage } from '@/features/settings/locations/locations-page';

export interface LocationsSearch {
  /** The table's kind filter. */
  kind?: 'seaport' | 'airport';
  /** The table's text filter (code or name). */
  q?: string;
  /** The selected unresolved alias. */
  alias?: string;
  /** The pin picker is open for the selected alias. */
  pin?: boolean;
}

/** `?kind=seaport&q=gen&alias=<id>&pin=1`: the filters and the open alias, so a link opens them. */
export const Route = createFileRoute('/_app/settings/locations')({
  validateSearch: (search: Record<string, unknown>): LocationsSearch => ({
    ...(search.kind === 'seaport' || search.kind === 'airport' ? { kind: search.kind } : {}),
    ...(typeof search.q === 'string' && search.q.length <= 64 && search.q ? { q: search.q } : {}),
    ...(typeof search.alias === 'string' && /^[\w-]{1,36}$/.test(search.alias)
      ? { alias: search.alias }
      : {}),
    ...(search.pin === true || search.pin === 1 || search.pin === '1' || search.pin === 'true'
      ? { pin: true }
      : {}),
  }),
  component: LocationsPage,
});
